'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ReactDOM = require('react-dom');

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var PageSize = /** @class */ (function () {
    function PageSize() {
    }
    PageSize.createNullObject = function () {
        var data = new PageSize();
        data.height = 0;
        data.width = 0;
        return data;
    };
    PageSize.create = function (height, width) {
        var data = new PageSize();
        data.height = height;
        data.width = width;
        return data;
    };
    return PageSize;
}());
var PageProperties = /** @class */ (function () {
    function PageProperties() {
    }
    PageProperties.create = function (page, scale) {
        var data = new PageProperties();
        data.page = page;
        data.scale = scale;
        return data;
    };
    return PageProperties;
}());

var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader(props) {
        return _super.call(this, props) || this;
    }
    Loader.prototype.render = function () {
        var parentElement = document.getElementById("page-viewer");
        var top = 0;
        var height = '0%';
        var left = 0;
        var width = '100%';
        if (parentElement && this.props.show) {
            height = parentElement.getBoundingClientRect().height;
            width = parentElement.getBoundingClientRect().width;
        }
        return (React.createElement("div", { style: { top: top, left: left, width: width, height: height }, className: this.props.show ? "awesome-pdf-viewer-loader visible" : "awesome-pdf-viewer-loader" },
            React.createElement("div", { "data-loader": "circle-side", className: "icon" })));
    };
    return Loader;
}(React.Component));

var PDFJSViewer = require("pdfjs-dist/web/pdf_viewer");
var PDFJSThumbnailViewer = require("pdfjs-dist/lib/web/pdf_thumbnail_viewer");
var PDFJSOutlineViewer = require("pdfjs-dist/lib/web/pdf_outline_viewer");
var PDFJSLinkService = require("pdfjs-dist/lib/web/pdf_link_service");
var ViewerMode;
(function (ViewerMode) {
    ViewerMode[ViewerMode["Normal"] = 0] = "Normal";
    ViewerMode[ViewerMode["Read"] = 1] = "Read";
})(ViewerMode || (ViewerMode = {}));
var PageMode;
(function (PageMode) {
    PageMode[PageMode["SinglePage"] = 1] = "SinglePage";
    PageMode[PageMode["MultiPage"] = 2] = "MultiPage";
    PageMode[PageMode["Classic"] = 3] = "Classic";
})(PageMode || (PageMode = {}));
var PageMatchesCount = /** @class */ (function () {
    function PageMatchesCount() {
    }
    PageMatchesCount.createNullObject = function () {
        var data = new PageMatchesCount();
        data.page = 0;
        data.matchCount = 0;
        return data;
    };
    PageMatchesCount.create = function (page, matchCount) {
        var data = new PageMatchesCount();
        data.page = page;
        data.matchCount = matchCount;
        return data;
    };
    return PageMatchesCount;
}());
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    SearchResult.createNullObject = function () {
        var data = new SearchResult();
        data.matchCount = 0;
        data.pagesMatch = [];
        return data;
    };
    SearchResult.create = function (matchesCount, pagesMatches) {
        var data = new SearchResult();
        data.matchCount = matchesCount;
        data.pagesMatch = pagesMatches;
        return data;
    };
    return SearchResult;
}());
var PdfSource = /** @class */ (function () {
    function PdfSource() {
    }
    PdfSource.createNullObject = function () {
        return new PdfSource();
    };
    PdfSource.createFromUrl = function (url) {
        var data = new PdfSource();
        data.url = url;
        return data;
    };
    PdfSource.createFromBase64 = function (base64String) {
        var data = new PdfSource();
        data.base64String = base64String;
        return data;
    };
    return PdfSource;
}());
var PdfJSSource = /** @class */ (function (_super) {
    __extends(PdfJSSource, _super);
    function PdfJSSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PdfJSSource.createPDFDocumentProxy = function (pdfDocumentProxy) {
        var data = new PdfJSSource();
        data.pdfDocumentProxy = pdfDocumentProxy;
        return data;
    };
    return PdfJSSource;
}(PdfSource));
var ViewerBase = /** @class */ (function () {
    function ViewerBase() {
        var _this = this;
        this.getEventBus = function () {
            _this._eventBus = new PDFJSViewer.EventBus();
            return _this._eventBus;
        };
        this.getCurrentPage = function () {
            return _this._pdfViewer.currentPageNumber;
        };
        this.gotoPage = function (page) {
            _this._pdfViewer.currentPageNumber = page;
        };
        this.getPageSize = function (page) {
            var currentPage = _this._pdfViewer._pages[page - 1];
            if (currentPage != null) {
                return PageSize.create(currentPage.viewport.height / currentPage.viewport.scale, currentPage.viewport.width / currentPage.viewport.scale);
            }
            else {
                return PageSize.createNullObject();
            }
        };
        this.setScale = function (scale) {
            _this._pdfViewer.currentScale = scale;
        };
        this.getCurrentScale = function () {
            return _this._pdfViewer.currentScale;
        };
        this.getTotalPages = function () {
            return _this._pdfViewer.pagesCount;
        };
        this.getBookmark = function (page) {
            var pageObj = _this._bookmarkViewer.outline && _this._bookmarkViewer.outline[page - 1];
            if (pageObj) {
                return pageObj.title;
            }
            return "";
        };
        this.scrollThumbnailIntoView = function (page) {
            _this._thumbnailViewer &&
                _this._thumbnailViewer.scrollThumbnailIntoView(page);
        };
        this.findText = function (textToFind) {
            var _self = _this;
            _this._pdfFindController.executeCommand("find", {
                query: textToFind,
                caseSensitive: false,
                entireWord: false,
                findPrevious: undefined,
                highlightAll: true,
                phraseSearch: true
            });
            var promise = new Promise(function (resolve) {
                window.setTimeout(function () {
                    var pages = [];
                    _self._pdfFindController._pageMatches.forEach(function (item, index) {
                        item.length > 0 &&
                            pages.push(PageMatchesCount.create(index + 1, item.length)); // adding pages and matched count
                    });
                    var searchResult = SearchResult.create(_self._pdfFindController._matchesCountTotal, pages);
                    resolve(searchResult);
                }, 1000);
            });
            return promise;
        };
        this.initializeLinkService();
    }
    ViewerBase.create = function () {
        return new ViewerBase();
    };
    ViewerBase.prototype.initializePdfFindController = function () {
        this._pdfFindController = new PDFJSViewer.PDFFindController({
            eventBus: this._eventBus,
            linkService: this._pdfLinkService
        });
    };
    ViewerBase.prototype.initializeViewer = function (container, pageMode, disableTextLayer) {
        if (pageMode == PageMode.SinglePage) {
            this._pdfViewer = new PDFJSViewer.PDFSinglePageViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                findController: this._pdfFindController,
                textLayerMode: disableTextLayer ? 0 : 1
            });
        }
        else {
            this._pdfViewer = new PDFJSViewer.PDFViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                findController: this._pdfFindController,
                textLayerMode: disableTextLayer ? 0 : 1,
                renderInteractiveForms: false
            });
        }
        this._pdfLinkService.setViewer(this._pdfViewer);
    };
    ViewerBase.prototype.initializeThumbnailViewer = function (container) {
        if (container) {
            this._thumbnailViewer = new PDFJSThumbnailViewer.PDFThumbnailViewer({
                container: container,
                linkService: this._pdfLinkService,
                renderingQueue: this._pdfViewer.renderingQueue
            });
            this._pdfViewer.renderingQueue.isThumbnailViewEnabled = true;
            this._pdfViewer.renderingQueue.setThumbnailViewer(this._thumbnailViewer);
        }
    };
    ViewerBase.prototype.initializeBookmarkViewer = function (container) {
        if (container) {
            this._bookmarkViewer = this._bookmarkViewer;
            this._bookmarkViewer = new PDFJSOutlineViewer.PDFOutlineViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                initialViewState: "outline"
            });
        }
    };
    ViewerBase.prototype.initializeLinkService = function () {
        this._pdfLinkService = new PDFJSLinkService.PDFLinkService();
    };
    ViewerBase.prototype.setDocument = function (document) {
        this._pdfViewer.setDocument(document);
        if (this._thumbnailViewer) {
            this._thumbnailViewer.setDocument(document);
            this.renderBookmarkList(document);
        }
        this._pdfLinkService.setDocument(document, null);
    };
    ViewerBase.prototype.setPdfPage = function (container, document, page, scale, disableTextLayer, renderInteractiveForms, onAfterDraw) {
        var _self = this;
        var promise = new Promise(function (resolve) {
            document.getPage(page).then(function (pdfPage) {
                container.innerHTML = "";
                _self._pdfViewer = new PDFJSViewer.PDFPageView({
                    eventBus: _self._eventBus,
                    // linkService: _self._pdfLinkService,
                    container: container,
                    id: page,
                    scale: scale,
                    defaultViewport: pdfPage.getViewport(page),
                    renderInteractiveForms: renderInteractiveForms == undefined ? true : renderInteractiveForms,
                    // findController: _self._pdfFindController,
                    textLayerMode: disableTextLayer ? 0 : 1,
                    textLayerFactory: new PDFJSViewer.DefaultTextLayerFactory(),
                    onAfterDraw: onAfterDraw
                });
                _self._pdfViewer.setPdfPage(pdfPage);
                _self._pdfViewer.draw();
                resolve(page);
            });
        });
        return promise;
    };
    ViewerBase.prototype.renderBookmarkList = function (document) {
        var _self = this;
        document.getOutline().then(function (outline) {
            _self._bookmarkViewer.render({ outline: outline });
        });
    };
    return ViewerBase;
}());

var Strings_BookmarkPanel = /** @class */ (function () {
    function Strings_BookmarkPanel() {
    }
    Strings_BookmarkPanel.thumbnailButtonTooltip = "Show Thumbnails";
    Strings_BookmarkPanel.bookmarkListButtonTooltip = "Show Document Bookmarks (click to expand/collapse all items)";
    Strings_BookmarkPanel.thumbnailContainerId = "page-thumbnail-view";
    Strings_BookmarkPanel.bookmarkListContainerId = "page-bookmark-view";
    return Strings_BookmarkPanel;
}());

var Viewer = /** @class */ (function (_super) {
    __extends(Viewer, _super);
    function Viewer(props) {
        var _this = _super.call(this, props) || this;
        _this._viewerBase = ViewerBase.create();
        _this.setDocument = function (doc) {
            _this._viewerBase.setDocument(doc);
        };
        _this.getCurrentPage = function () {
            return _this._viewerBase.getCurrentPage();
        };
        _this.getPageSize = function (page) {
            return _this._viewerBase.getPageSize(page);
        };
        _this.gotoPage = function (page) {
            _this._viewerBase.gotoPage(page);
        };
        _this.setScale = function (scale) {
            _this._viewerBase.setScale(scale);
        };
        _this.getCurrentScale = function () {
            return _this._viewerBase.getCurrentScale();
        };
        _this.getTotalPages = function () {
            return _this._viewerBase.getTotalPages();
        };
        _this.getBookmark = function (page) {
            return _this._viewerBase.getBookmark(page);
        };
        _this.searchText = function (textToFind) {
            return _this._viewerBase.findText(textToFind);
        };
        _this.setLoaderStatus = function (status) {
            _this.setState({ showLoader: status });
        };
        _this.setViewerMode = function (viewerMode) {
            _this.setState({ viewerMode: viewerMode });
        };
        _this.initEventBus();
        _this.state = {
            showLoader: true,
            viewerMode: ViewerMode.Normal
        };
        return _this;
    }
    Viewer.prototype.initEventBus = function () {
        var _this = this;
        var eventBus = this._viewerBase.getEventBus();
        eventBus.on('pagesinit', function () {
            var pageProperties = PageProperties.create(_this._viewerBase.getCurrentPage(), _this._viewerBase.getCurrentScale());
            _this.props.onDocumentLoad && _this.props.onDocumentLoad(pageProperties);
        });
        eventBus.on('scalechanging', function (e) {
            if (_this.props.onScaleChanged) {
                _this.props.onScaleChanged(PageProperties.create(_this._viewerBase.getCurrentPage(), e.scale));
            }
        });
        eventBus.on('pagerendered', function (e) {
            _this.state.showLoader && _this.setState({ showLoader: false });
            if (_this.props.onPageChanged) {
                _this.props.onPageChanged(PageProperties.create(e.pageNumber, _this._viewerBase.getCurrentScale()));
            }
            _this._viewerBase.scrollThumbnailIntoView(e.pageNumber);
        });
        eventBus.on('pagechanging', function (e) {
            if (_this.props.onPageChanging) {
                var pageProperties = PageProperties.create(e.pageNumber, _this._viewerBase.getCurrentScale());
                _this.props.onPageChanging(pageProperties);
            }
        });
    };
    Viewer.prototype.componentDidMount = function () {
        var _a = this.props, pageMode = _a.pageMode, disableTextLayer = _a.disableTextLayer;
        var viewerContainer = ReactDOM.findDOMNode(this);
        this._viewerBase.initializePdfFindController();
        this._viewerBase.initializeViewer(viewerContainer, pageMode, disableTextLayer);
        this._viewerBase.initializeThumbnailViewer(document.getElementById(Strings_BookmarkPanel.thumbnailContainerId));
        this._viewerBase.initializeBookmarkViewer(document.getElementById(Strings_BookmarkPanel.bookmarkListContainerId));
    };
    Viewer.prototype.render = function () {
        var viewerReadModeClass = this.state.viewerMode == ViewerMode.Read ? " read-mode-enabled " : "";
        return (React.createElement("div", { className: "page-viewer " + viewerReadModeClass, id: "page-viewer" },
            React.createElement("div", { className: "pdfViewer", id: "pdfViewer" }),
            this.props.children,
            React.createElement(Loader, { show: this.state.showLoader })));
    };
    return Viewer;
}(React.Component));

var ClassicPageViewer = /** @class */ (function (_super) {
    __extends(ClassicPageViewer, _super);
    function ClassicPageViewer(props) {
        var _this = _super.call(this, props) || this;
        _this._totalPages = 0;
        _this._pageNum = 1;
        _this._scale = 1;
        _this._viewerBase = ViewerBase.create();
        _this.setDocument = function (doc) {
            var _self = _this;
            var onDocumentLoad = _self.props.onDocumentLoad;
            _self._documentData = doc;
            _self._totalPages = _this._documentData.numPages;
            _self._pageNum = 1;
            _self.renderPage(_self._pageNum, _self._scale).then(function (pdfPage) {
                pdfPage = pdfPage;
                var pageProperties = PageProperties.create(_self._pageNum, _self._scale);
                onDocumentLoad && onDocumentLoad(pageProperties);
            });
        };
        _this.getCurrentPage = function () {
            return _this._pageNum;
        };
        _this.getPageSize = function (page) {
            page = page;
            var currentPage = _this._viewerBase._pdfViewer;
            if (currentPage != null) {
                return PageSize.create(currentPage.viewport.height / currentPage.viewport.scale, currentPage.viewport.width / currentPage.viewport.scale);
            }
            else {
                return PageSize.createNullObject();
            }
        };
        _this.gotoPage = function (page) {
            var _self = _this;
            _self._pageNum = page;
            var onPageChanging = _self.props.onPageChanging;
            _this.renderPage(_this._pageNum, _this._scale).then(function (pdfPage) {
                pdfPage = pdfPage;
                onPageChanging && onPageChanging(PageProperties.create(_self._pageNum, _self._scale));
            });
        };
        _this.setScale = function (scale) {
            var _self = _this;
            var onScaleChanged = _self.props.onScaleChanged;
            _self._scale = scale;
            // _self.renderPage(_self._pageNum, _self._scale, onScaleChanged);
            _self.renderPage(_self._pageNum, _self._scale).then(function (pdfPage) {
                pdfPage = pdfPage;
                onScaleChanged && onScaleChanged(PageProperties.create(_self._pageNum, _self._scale));
            });
        };
        _this.getCurrentScale = function () {
            return _this._scale;
        };
        _this.getTotalPages = function () {
            return _this._totalPages;
        };
        _this.getBookmark = function (page) {
            page = page;
            return "1";
        };
        _this.searchText = function (textToFind) {
            return _this._viewerBase.findText(textToFind);
        };
        _this.setLoaderStatus = function (status) {
            _this.setState({ showLoader: status });
        };
        _this.setViewerMode = function (viewerMode) {
            viewerMode = viewerMode;
        };
        _this.renderPage = function (page, scale, onAfterDraw) {
            var disableTextLayer = _this.props.disableTextLayer;
            var renderInteractiveForms = _this.props.renderInteractiveForms;
            var viewerContainer = document.getElementById('pdfViewer');
            return _this._viewerBase.setPdfPage(viewerContainer, _this._documentData, page, scale, disableTextLayer, renderInteractiveForms, onAfterDraw);
        };
        _this.initEventBus();
        _this.state = {
            showLoader: true,
            viewerMode: ViewerMode.Normal
        };
        return _this;
    }
    ClassicPageViewer.prototype.initEventBus = function () {
        var _this = this;
        var eventBus = this._viewerBase.getEventBus();
        eventBus.on('pagerendered', function (e) {
            _this.state.showLoader && _this.setState({ showLoader: false });
            if (_this.props.onPageChanged) {
                _this.props.onPageChanged(PageProperties.create(_this._pageNum, _this._scale));
            }
            _this._viewerBase.scrollThumbnailIntoView(e.pageNumber);
        });
    };
    ClassicPageViewer.prototype.componentDidMount = function () {
    };
    ClassicPageViewer.prototype.render = function () {
        var viewerReadModeClass = this.state.viewerMode == ViewerMode.Read ? " read-mode-enabled " : "";
        return (React.createElement("div", { className: "page-viewer " + viewerReadModeClass, id: "page-viewer" },
            React.createElement("div", { className: "pdfViewer", id: "pdfViewer" }),
            this.props.children,
            React.createElement(Loader, { show: this.state.showLoader })));
    };
    return ClassicPageViewer;
}(React.Component));

var PDFJS = require('pdfjs-dist');
var pdfjsWorker = require('pdfjs-dist/build/pdf.worker.entry');
var FileClient = /** @class */ (function () {
    function FileClient() {
        PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    }
    FileClient.prototype.download = function (url) {
        return new Promise(function (resolve, reject) {
            var loadingTask = PDFJS.getDocument(url);
            loadingTask.promise.then(function (doc) {
                resolve(doc);
            }, function (error) {
                reject(error);
            });
        });
    };
    FileClient.prototype.getDocument = function (base64Data) {
        var pdfData = atob(base64Data);
        return new Promise(function (resolve, reject) {
            var loadingTask = PDFJS.getDocument({ data: pdfData });
            loadingTask.promise.then(function (doc) {
                resolve(doc);
            }, function (error) {
                reject(error);
            });
        });
    };
    FileClient.create = function () {
        return new FileClient();
    };
    return FileClient;
}());
var IEFileClient = /** @class */ (function () {
    function IEFileClient() {
        PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    }
    IEFileClient.prototype.download = function (url) {
        return new Promise(function (resolve, reject) {
            fetch(url).then(function (response) {
                if (response.ok) {
                    return response.blob();
                }
                throw new Error('Error in network response/slow network !!');
            }).then(function (responseData) {
                var objectURL = URL.createObjectURL(responseData);
                var loadingTask = PDFJS.getDocument(objectURL);
                loadingTask.promise.then(function (doc) {
                    resolve(doc);
                }, function (error) {
                    reject(error);
                });
            }).catch(function (error) {
                reject(error);
            });
        });
    };
    IEFileClient.prototype.getDocument = function (base64Data) {
        var pdfData = atob(base64Data);
        return new Promise(function (resolve, reject) {
            var loadingTask = PDFJS.getDocument({ data: pdfData });
            loadingTask.promise.then(function (doc) {
                resolve(doc);
            }, function (error) {
                reject(error);
            });
        });
    };
    IEFileClient.create = function () {
        return new IEFileClient();
    };
    return IEFileClient;
}());

var FileClientFactory = /** @class */ (function () {
    function FileClientFactory() {
    }
    FileClientFactory.getFileClient = function () {
        try {
            if (/msie\s|trident\/|edge\//i.test(window.navigator.userAgent)) {
                return new IEFileClient();
            }
            else {
                return new FileClient();
            }
        }
        catch (error) {
            return new FileClient();
        }
    };
    return FileClientFactory;
}());

var ViewPanel = /** @class */ (function (_super) {
    __extends(ViewPanel, _super);
    function ViewPanel(props) {
        var _this = _super.call(this, props) || this;
        _this._pdfJsFileClient = FileClientFactory.getFileClient();
        _this.loadPDF = function (source) {
            if (source.url) {
                _this.loadFromUrl(source.url);
            }
            else if (source.base64String) {
                _this.loadPdfFromBase64(source.base64String);
            }
            else if (source.pdfDocumentProxy) {
                _this.loadFromPDFDocumentProxy(source.pdfDocumentProxy);
            }
            else {
                _this.loadFromUrl("");
            }
        };
        _this.loadFromUrl = function (url) {
            var _self = _this;
            url && _this._pdfJsFileClient.download(url)
                .then(function (doc) {
                _self.documentReady(doc);
                if (_self._viewer) {
                    _self._viewer.setDocument(doc);
                    _self._viewer.setScale(_this.getInitialScaleBaseOnScreenWidth());
                }
            }, function (error) {
                console.error(error);
            });
        };
        _this.loadPdfFromBase64 = function (base64Data) {
            var _self = _this;
            _this._pdfJsFileClient.getDocument(base64Data)
                .then(function (doc) {
                _self.documentReady(doc);
                if (_self._viewer) {
                    _self._viewer.setDocument(doc);
                    _self._viewer.setScale(_this.getInitialScaleBaseOnScreenWidth());
                }
            }, function (error) {
                console.error(error);
            });
        };
        _this.loadFromPDFDocumentProxy = function (pdfDocumentProxy) {
            _this.documentReady(pdfDocumentProxy);
            if (_this._viewer) {
                _this._viewer.setDocument(pdfDocumentProxy);
                _this._viewer.setScale(_this.getInitialScaleBaseOnScreenWidth());
            }
        };
        _this.zoomIn = function () {
            if (_this._viewer) {
                _this._viewer.setScale(_this._viewer.getCurrentScale() * 1.1);
                _this.props.onScaleChanged && _this.props.onScaleChanged(_this._viewer.getCurrentScale());
            }
        };
        _this.zoomOut = function () {
            if (_this._viewer) {
                _this._viewer.setScale(_this._viewer.getCurrentScale() / 1.1);
                _this.props.onScaleChanged && _this.props.onScaleChanged(_this._viewer.getCurrentScale());
            }
        };
        _this.zoomChange = function (scale) {
            if (_this._viewer) {
                _this._viewer.setScale(scale);
                _this.props.onScaleChanged && _this.props.onScaleChanged(_this._viewer.getCurrentScale());
            }
        };
        _this.nextPage = function () {
            _this._viewer && _this._viewer.gotoPage(_this._viewer.getCurrentPage() + 1);
        };
        _this.previousPage = function () {
            _this._viewer && _this._viewer.gotoPage(_this._viewer.getCurrentPage() - 1);
        };
        _this.gotoPage = function (page) {
            _this._viewer && _this._viewer.gotoPage(page);
        };
        _this.getTotalPages = function () {
            return _this._viewer ? _this._viewer.getTotalPages() : 0;
        };
        _this.getCurrentPageNumber = function () {
            return _this._viewer ? _this._viewer.getCurrentPage() : 0;
        };
        _this.getPageSize = function (page) {
            return _this._viewer ? _this._viewer.getPageSize(page) : PageSize.createNullObject();
        };
        _this.searchText = function (textToFind) {
            return _this._viewer && _this._viewer.searchText(textToFind);
        };
        _this.getDocument = function () {
            return _this._document;
        };
        _this.setViewerMode = function (viewerMode) {
            _this._viewer && _this._viewer.setViewerMode(viewerMode);
        };
        _this.resetCurrentStepFocus = function () {
            _this._controlLayer && _this._controlLayer.resetCurrentStepFocus();
        };
        //#region setReference Methods
        _this.setToolbarReference = function (toolbar) {
            _this._toolbar = toolbar;
        };
        _this.setControlsReference = function (controls) {
            _this._controls = controls;
        };
        _this.setControlLayerReference = function (controlLayer) {
            _this._controlLayer = controlLayer;
        };
        _this.setBookmarkPanelReference = function (bookmarkPanel) {
            _this._bookmarkPanel = bookmarkPanel;
        };
        //#endregion
        //#region Validate Reference region
        _this.validateToolbarReference = function () {
            return _this._toolbar ? true : false;
        };
        _this.validateControlsReference = function () {
            return _this._controls ? true : false;
        };
        _this.validateControlLayerReference = function () {
            return _this._controlLayer ? true : false;
        };
        _this.validateBookmarkPanelReference = function () {
            return !_this._bookmarkPanel;
        };
        //#endregion
        //#region  Reference Events
        _this.updateControlState = function (pageProperties) {
            var _self = _this;
            pageProperties = pageProperties;
            _self._controls && _self._controls.forEach(function (item) {
                item && item.updateControlState(pageProperties);
            });
            _this.resetCurrentStepFocus();
        };
        _this.updateControlLayerState = function (pageProperties) {
            if (_this.validateControlLayerReference()) {
                _this._controlLayer.updateState(pageProperties);
            }
        };
        _this.setBookmarkPanelDocument = function (document) {
            if (_this._bookmarkPanel) {
                _this._bookmarkPanel.setDocument(document);
            }
        };
        //#endregion
        //#region Viewer Events
        _this.documentReady = function (document) {
            _this._document = document;
            _this.setBookmarkPanelDocument(document);
        };
        _this.handleDocumentLoad = function (pageProperties) {
            if (_this.validateToolbarReference()) {
                _this._toolbar.updateState(pageProperties);
            }
            if (_this.validateControlLayerReference()) {
                _this._controlLayer.removeAllNavigationSteps();
            }
            if (_this.props.onDocumentLoad) {
                _this.props.onDocumentLoad && _this.props.onDocumentLoad(pageProperties);
            }
            _this._controlLayer && _this._controlLayer.closeNavigation();
            if (_this.props.defaultPage)
                _this._viewer && _this._viewer.gotoPage(_this.props.defaultPage);
        };
        _this.handlePageChanging = function (pageProperties) {
            if (_this.validateToolbarReference()) {
                _this._toolbar.updateState(pageProperties);
            }
            if (_this.props.onPageChanged) {
                _this.props.onPageChanged(pageProperties);
            }
            _this.resetCurrentStepFocus();
        };
        _this.handlePageChanged = function (pageProperties) {
            _this.updateControlState(pageProperties);
            _this._controlLayer && _this._controlLayer.updateState(pageProperties);
        };
        _this.state = {};
        return _this;
    }
    ViewPanel.prototype.componentDidMount = function () {
        this.loadPDF(this.props.pdfSource);
    };
    ViewPanel.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        nextProps = nextProps;
        nextState = nextState;
        if ((nextProps.url && this.props.url !== nextProps.url) ||
            (nextProps.pdfData && this.props.pdfData !== nextProps.pdfData) ||
            (nextProps.pdfSource && !nextProps.pdfSource.url && this.props.pdfSource !== nextProps.pdfSource) ||
            (nextProps.pdfSource && nextProps.pdfSource.url && this.props.pdfSource.url !== nextProps.pdfSource.url)) {
            if (this._viewer) {
                this._viewer.setLoaderStatus(true);
                this.loadPDF(nextProps.pdfSource);
            }
            return false;
        }
        return false;
    };
    ViewPanel.prototype.getInitialScaleBaseOnScreenWidth = function () {
        if (this.props.customWidth) {
            return (this.props.customWidth / 1200) + .10;
        }
        return screen.width >= 1200 ? 1 : (screen.width / 1200) + .10; // scree size >= 1200 is laptop so scale will be set to 1
    };
    ViewPanel.prototype.displayScaleChanged = function (e) {
        e = e;
    };
    //#endregion
    //#region Public events
    ViewPanel.prototype.getBookmark = function (page) {
        return this._viewer ? this._viewer.getBookmark(page) : "";
    };
    //#endregion
    ViewPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, pageMode = _a.pageMode, disableTextLayer = _a.disableTextLayer, renderInteractiveForms = _a.renderInteractiveForms, children = _a.children;
        if (pageMode == PageMode.Classic) {
            return (React.createElement(ClassicPageViewer, { ref: function (ref) { return _this._viewer = ref; }, onDocumentLoad: this.handleDocumentLoad, onPageChanging: this.handlePageChanging, pageMode: pageMode, onPageChanged: this.handlePageChanged, disableTextLayer: disableTextLayer, renderInteractiveForms: renderInteractiveForms }, children));
        }
        else {
            return (React.createElement(Viewer, { ref: function (ref) { return _this._viewer = ref; }, onDocumentLoad: this.handleDocumentLoad, onPageChanging: this.handlePageChanging, pageMode: pageMode, onPageChanged: this.handlePageChanged, disableTextLayer: disableTextLayer }, children));
        }
    };
    return ViewPanel;
}(React.Component));

exports.default = ViewPanel;
exports.ViewPanel = ViewPanel;
